import { BusinessPostDto } from "./../../../@types/dtos/business/BusinessPostDto";
import { useCurrentTenant } from "@drift/oneplatfront";
import { usePost, useAuth } from "@onefront/react-sdk";
import { generateHeaders } from "../../../utils/generate-headers";

interface IParamsFetch {
    params?: any;
    headers?: any;
    data: BusinessPostDto;
}

interface IusePostBusiness {
    (workspaceId?: string, params?: any | object, lazy?: boolean): {
        data?: BusinessPostDto;
        loading?: boolean;
        fetch: (fetchConfig: IParamsFetch) => Promise<any>;
        error: boolean;
    };
}

export const usePostBusiness: IusePostBusiness = (workspaceId, params = {}, lazy = true) => {
    const { tenant } = useCurrentTenant(true);
    return usePost(
        `rnd:core:workspace-write:api://v1/workspaces/${workspaceId}/business`,
        {},
        {
            params: {
                ...params
            },
            headers: generateHeaders(useAuth(), tenant?.itemId, workspaceId),
            lazy
        }
    );
};
